import { mapToBreakpoints } from '../../../mixins/mapToBreakpoints.js';

const getFlexDirectionStyle = values => {
  return mapToBreakpoints(values, value => {
    return `
      flex-direction: ${value};
    `;
  });
};

export { getFlexDirectionStyle };
//# sourceMappingURL=getFlexDirectionStyle.js.map
